import { ReactNode } from 'react';

type Tone = 'default' | 'success' | 'warning' | 'danger' | 'info';
type Size = 'sm' | 'lg';

// The four fixed semantic status pairs from the Teal-theme spec (never themed,
// never decorative). `danger` keeps a red pair for cancelled/voided/overdue.
const TONES: Record<Tone, string> = {
  default: 'bg-[#E9EAEE] text-[#5A5F6A]', // draft / raw / inactive
  success: 'bg-[#D9F2E2] text-[#14633C]', // posted / completed / finished
  warning: 'bg-[#FBE3CC] text-[#8A4B15]', // planned / service / warning — warm apricot (was pale yellow)
  info:    'bg-[#E0ECFB] text-[#2D5596]', // open / new / sub-assembly / info
  danger:  'bg-[#F7DEDC] text-[#A62F27]', // cancelled / voided / overdue (5.38:1; #BF3A32 was 4.25:1)
};

// Size "sm" is the default — used in tables, status columns, anywhere the
// badge is one of many. "lg" is for the prominent document status badge
// in the Header card on detail pages.
const SIZES: Record<Size, string> = {
  sm: 'px-2 py-0.5 text-label leading-[inherit]',
  lg: 'px-3 py-1 text-title leading-[inherit]',
};

export function Badge({ tone = 'default', size = 'sm', children }: { tone?: Tone; size?: Size; children: ReactNode }) {
  return (
    <span className={`inline-flex items-center rounded-full font-semibold tracking-tight ${SIZES[size]} ${TONES[tone]}`}>
      {children}
    </span>
  );
}
